import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import firebase from './Firebase';
import server from '../api/server';
import history from '../history';

export class ClientLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: "Active_Forms",
            email: "",
            password: "",
            errorMessage: "",
            logged_in: true,
            emailSent: false,
            error: ""
        };
    }

    componentDidMount() {
        this.checkAuth();
    }

    checkAuth = () => {
   
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                console.log('logged in.');
                var response = await server.post("/client/auth/redirect").catch(e => {
                    this.setState({ logged_in: false });
                });
                if (response && response.data != false) {
                    var application_id = response.data.application_id;
                    history.push(`/dashboard/${application_id}`);
                } else {
                    this.setState({ logged_in: false });
                }
                // User is signed in.
            } else {

                this.setState({ logged_in: false });
                // history.push("/login");
                // No user is signed in.
            }
        });
    };
    handleSubmit = async (e) => {
        e.preventDefault();
        const email = this.state.email.trim();
        if (!email) {
            return this.setState({ errorMessage: "Please enter your email." });
        }

        this.setState({ logging_in: true, errorMessage: "" });

        // The sign-in link is now generated server-side (Firebase Admin SDK) and
        // delivered inside a branded LoanGateway email. The backend deliberately
        // returns a generic success whether or not the address is registered
        // (anti-enumeration), so we always show the confirmation screen.
        try {
            await server.post("/client/sendLoginLink", { email });
        } catch (err) {
            // Only a network/transport failure reaches here — the endpoint itself
            // never signals whether the email exists.
        }

        // Same-device convenience: ClientAuthRedirect reads this to complete the
        // sign-in without re-prompting for the email.
        window.localStorage.setItem('emailForSignIn', email);
        this.setState({ emailSent: true, logging_in: false });
    };

    renderHelmet = () => {
        return (
            <Helmet defer={false}>
                {/*
                  Toggle the modern-page body styles via <html className>.
                  See client/src/index.css ".lg-modern-page" rules - they
                  override the legacy /css/loader.css (which forces
                  html/body to 100px), hide the full-screen .full-loader
                  overlay, and set the modern background + font. Using
                  <html> attributes (instead of an inline <style> tag)
                  ensures react-helmet@6.1 correctly REMOVES them on
                  unmount so they don't leak into /admin pages (which
                  would otherwise lose Poppins font + Metronic's flex
                  layout).
                */}
                <html className="lg-modern-page" />
                <meta charSet="utf-8" />
                <title>Login | LoanGateway</title>
                <meta name="description" content="Sign in to LoanGateway" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, shrink-to-fit=no"
                />
                <link rel="shortcut icon" href="assets/media/logos/favicon.ico" />
            </Helmet>
        );
    };

    renderLoader = () => {
        return (
            <div
                className="min-h-screen w-full flex flex-col items-center justify-center px-6"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                {this.renderHelmet()}
                <img
                    src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
                    alt="LoanGateway"
                    className="h-10 sm:h-12 w-auto mb-6"
                />
                <span
                    className="inline-block h-6 w-6 rounded-full border-2 border-[#E5E7EB] animate-spin"
                    style={{ borderTopColor: '#7C5CFC' }}
                />
            </div>
        );
    };

    renderSignInForm = () => {
        return (
            <form
                onSubmit={(e) => { this.handleSubmit(e); }}
                noValidate
                className="w-full max-w-md"
            >
                <div className="mb-8">
                    <h1 className="text-2xl sm:text-3xl font-bold text-[#1F2937]">Sign in</h1>
                    <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                        Please provide the email used to sign in below. We'll send a secure
                        sign-in link straight to your inbox.
                    </p>
                </div>

                <div className="mb-5">
                    <label
                        htmlFor="client-login-email"
                        className="block text-sm font-medium text-[#1F2937] mb-2"
                    >
                        Email <span style={{ color: '#DC2626' }}>*</span>
                    </label>
                    <input
                        id="client-login-email"
                        type="email"
                        name="username"
                        autoComplete="email"
                        required
                        value={this.state.email}
                        onChange={(e) => { this.setState({ email: e.target.value }); }}
                        placeholder="you@example.com"
                        className="w-full rounded-xl border-2 border-[#E5E7EB] bg-white px-4 py-3 text-base text-[#1F2937] placeholder-[#9CA0AE] focus:outline-none focus:border-[#7C5CFC] transition-colors"
                    />
                    {this.state.errorMessage ? (
                        <p className="mt-2 text-sm" style={{ color: '#DC2626' }}>
                            {this.state.errorMessage}
                        </p>
                    ) : null}
                </div>

                <button
                    type="submit"
                    disabled={this.state.logging_in}
                    className="w-full rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{ backgroundColor: '#7C5CFC' }}
                >
                    Send Login Link →
                </button>
            </form>
        );
    };

    renderEmailSent = () => {
        return (
            <div className="w-full max-w-md">
                <div className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-6 sm:p-8">
                    <span
                        className="inline-flex items-center justify-center h-12 w-12 rounded-2xl mb-5"
                        style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}
                    >
                        <svg className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path
                                fillRule="evenodd"
                                d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </span>
                    <h1 className="text-2xl sm:text-3xl font-bold text-[#1F2937]">
                        Login email sent
                    </h1>
                    <p className="mt-3 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                        Follow the link sent to your email to sign in. If you can't see the
                        email in your inbox, check the spam or junk folder.
                    </p>
                </div>
            </div>
        );
    };

    render() {
        if (this.state.logged_in == true) {
            return this.renderLoader();
        } else {
            return (
                <div
                    className="min-h-screen w-full flex flex-col lg:flex-row"
                    style={{ backgroundColor: '#F5F6FA' }}
                >
                    {this.renderHelmet()}

                    {/* Form pane */}
                    <section className="flex-1 flex flex-col bg-white px-5 py-10 sm:px-8 lg:px-16 lg:py-16">
                        <div className="mb-10 sm:mb-12 flex justify-center lg:justify-start">
                            <img
                                src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
                                alt="LoanGateway"
                                className="h-8 sm:h-9 w-auto"
                            />
                        </div>

                        <div className="flex-1 flex flex-col justify-center items-center lg:items-start">
                            {this.state.emailSent
                                ? this.renderEmailSent()
                                : this.renderSignInForm()}
                        </div>

                        <p className="mt-10 text-center lg:text-left text-xs text-[#6B7280]">
                            Need a hand? Call us on{' '}
                            <a
                                href="tel:0292310511"
                                className="font-semibold"
                                style={{ color: '#5B3FE0' }}
                            >
                                02 9231 0511
                            </a>
                            .
                        </p>
                    </section>

                    {/* Brand feature pane */}
                    <section
                        className="hidden lg:flex flex-col justify-center px-12 py-16 w-1/2 max-w-2xl"
                        style={{ backgroundColor: '#1A1D2A' }}
                    >
                        <p
                            className="text-xs font-semibold tracking-widest uppercase mb-4"
                            style={{ color: '#C4B5FD' }}
                        >
                            LoanGateway
                        </p>
                        <h2 className="text-3xl xl:text-4xl font-bold text-white leading-tight">
                            Fact Find, Verification of Identity & Document Collection, made easy.
                        </h2>
                        <p className="mt-5 text-base text-[#C7CAD6] max-w-md leading-relaxed">
                            Made by brokers, for brokers. Securely share the details we need to
                            help with your enquiry. Your link, your data, your control.
                        </p>

                        <ul className="mt-10 space-y-3 text-sm text-[#C7CAD6]">
                            <li className="flex items-start gap-3">
                                <span
                                    className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                    style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                                >
                                    <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                        <path
                                            fillRule="evenodd"
                                            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </span>
                                Secure, broker-grade encryption end-to-end.
                            </li>
                            <li className="flex items-start gap-3">
                                <span
                                    className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                    style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                                >
                                    <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                        <path
                                            fillRule="evenodd"
                                            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </span>
                                Pick up where you left off, anytime, on any device.
                            </li>
                            <li className="flex items-start gap-3">
                                <span
                                    className="inline-flex items-center justify-center h-5 w-5 rounded-full flex-shrink-0 mt-0.5"
                                    style={{ backgroundColor: '#7C5CFC', color: '#FFFFFF' }}
                                >
                                    <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                        <path
                                            fillRule="evenodd"
                                            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </span>
                                Your unique link, your data, never shared.
                            </li>
                        </ul>
                    </section>
                </div>
            );
        }

    }

}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClientLogin);;
